import settings from '@config/settings'
import {
  isOwnerOrAdministrator,
  paths,
  selectCurrentUserRole,
  useAppSelector,
  useMerchantQry
} from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { NavLink } from 'react-router-dom'

interface Props {
  className?: string
  onClick?: () => void
}

function UserMenuItems({ className = undefined, onClick }: Props) {
  const customerRole = useAppSelector(selectCurrentUserRole)
  const { merchant } = useMerchantQry()
  const isDevelopersMenuVisible = Boolean(merchant?.apiEnabled) && isOwnerOrAdministrator(customerRole)

  return (
    <>
      <NavLink to={paths.profile()} onClick={onClick} className={className}>
        {tr('PORTAL.HEADER.PROFILE', 'Profile')}
      </NavLink>
      <NavLink to={paths.security()} onClick={onClick} className={className}>
        {tr('PORTAL.HEADER.SECURITY', 'Security')}
      </NavLink>
      {isOwnerOrAdministrator(customerRole) && (
        <NavLink to={paths.userManagement()} onClick={onClick} className={className}>
          {tr('PORTAL.HEADER.USERS', 'Users')}
        </NavLink>
      )}
      <a
        href={settings.customerServiceUrl}
        rel='noopener noreferrer'
        target='_blank'
        onClick={onClick}
        className={className}
      >
        {tr('PORTAL.HEADER.CUSTOMER_SERVICE', 'Customer service')}
      </a>
      {isDevelopersMenuVisible && (
        <NavLink to={paths.developer()} onClick={onClick} className={className}>
          {tr('PORTAL.HEADER.DEVELOPERS', 'Developers')}
        </NavLink>
      )}
    </>
  )
}

export default UserMenuItems
